import React from 'react';
export function withSentryErrorBoundary(ComponentToWrap, options, ErrorStateComponent) {
    return class SentryErrorBoundary extends React.Component {
        constructor() {
            super(...arguments);
            this.state = { error: null };
        }
        componentDidCatch(error) {
            if (this.state.error === null) {
                this.setState({ error });
            }
            const sentry = new this.props.host.LazySentry({
                dsn: options.dsn,
                ...options.config,
                release: this.props.sentryRelease,
            });
            if (!sentry) {
                return;
            }
            if (options.tags) {
                sentry.configureScope((scope) => {
                    Object.entries(options.tags).forEach(([tag, value]) => scope.setTag(tag, value));
                });
            }
            const userContextOverrides = this.props.ravenUserContextOverrides;
            if (options.userContext || userContextOverrides) {
                sentry.configureScope((scope) => {
                    scope.setUser({ ...options.userContext, ...userContextOverrides });
                });
            }
            sentry.captureException(error);
        }
        render() {
            return this.state.error && ErrorStateComponent ? (React.createElement(ErrorStateComponent, { error: this.state.error, ...this.props })) : (React.createElement(ComponentToWrap, { ...this.props }));
        }
    };
}
//# sourceMappingURL=sentry-error-boundary.js.map